module.exports = __webpack_public_path__ + "static/media/CiscoSansTTRegular.c09d7283.ttf";